export const TASKS_LOADER = 'TASKS_LOADER';
export const TASKS_SAVE_LOADER = 'TASKS_SAVE_LOADER';
export const GET_TASKS = 'GET_TASKS';
export const FORM_FAIL = "FORM_FAIL";
export const TASKS_FAIL = 'TASKS_FAIL';